<template>
  <div>
    <row :item1="item" :item2="item" :settings="settings" class="pa-4"></row>
  </div>
</template>

<script>
import Row from '@/components/toolbox/item-diff/components/row'
export default {
  props: ['item'],
  components: {
    Row
  },
  data () {
    return {
      settings: {
        showTypes: false
      }
    }
  }
}
</script>